import { ControlGroup } from "../ControlGroup";
import { useDebuggerGroupsMidgard } from "../useDebuggerGroups";

const ControlGroupMidgard = ({
  dataRequiredOnThisPage,
}: {
  dataRequiredOnThisPage: string[];
}) => {
  const { networkMetadata, resources } = useDebuggerGroupsMidgard();

  return (
    <ControlGroup
      title="Midgard"
      {...{ networkMetadata, resources, dataRequiredOnThisPage }}
    />
  );
};
export default ControlGroupMidgard;
